import IDelivery from '../models/IDelivery';
import AbstractCRUDService from './AbstractCRUDService';

class DeliveryService extends AbstractCRUDService<IDelivery> {}

export default new DeliveryService('shipping/delivery');
